import { About } from './components/About';
import { Contact } from './components/Contact';
import { FeaturedProject } from './components/FeaturedProject';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { SiteHeader } from './components/SiteHeader';
import { MotionController } from './components/MotionController';

export function App() {
  return (
    <>
      <MotionController />
      <SiteHeader />
      <main id="main-content">
        <Hero />
        <About />
        <Services />
        <FeaturedProject />
        <Contact />
      </main>
    </>
  );
}
